import { createFileRoute } from '@tanstack/react-router'
import { AdminPromoCodes } from '@/components/admin/marketing/AdminPromoCodes'

export const Route = createFileRoute('/admin/marketing/promo-codes')({
  component: () => <AdminPromoCodes />,
})
